export interface IParameter {
    "id": number,
    "issue": number,
    "label": string,
    "decimalDigits": number,
    "unitConverted": string,
    "calc": (v: number) => number,
}



export const parameterMap: IParameter[] = [
    {
        "id": 2440,
        "issue": 1612424,
        "label": "windDirection",
        "decimalDigits": 0,
        "unitConverted": "°",
        "calc": v => v
    },
    {
        "id": 2439,
        "issue": 1612423,
        "label": "windSpeed",
        "decimalDigits": 1,
        "unitConverted": "m/s",
        "calc": v => v * 0.5144444 // from [kts]
    },
    {
        "id": 2438,
        "issue": 1612422,
        "label": "windGust",
        "decimalDigits": 1,
        "unitConverted": "m/s",
        "calc": v => v * 0.5144444 // from [kts]
    },
    {
        "id": 2442,
        "issue": 1612426,
        "label": "airTemperature",
        "decimalDigits": 1,
        "unitConverted": "°C",
        "calc": v => v
    },
    {
        "id": 2441,
        "issue": 1612425,
        "label": "relativeHumidity",
        "decimalDigits": 0,
        "unitConverted": "%",
        "calc": v => v
    },
    {
        "id": 2445,
        "issue": 1612429,
        "label": "windChill",
        "decimalDigits": 1,
        "unitConverted": "°C",
        "calc": v => v
    },
    {
        "id": 2471,
        "issue": 1612455,
        "label": "airPressure",
        "decimalDigits": 0,
        "unitConverted": "mbar",
        "calc": v => v // from [hPa]
    },
    {
        "id": 1720,
        "issue": 428359,
        "label": "waterLevel",
        "decimalDigits": 2,
        "unitConverted": "mCD",
        "calc": v => v
    },
    {
        "id": 9991720,
        "issue": 428359,
        "label": "waterDepth",
        "decimalDigits": 2,
        "unitConverted": "mCD",
        "calc": v => 3.2 + v
    },
    {
        "id": 1721,
        "issue": 428360,
        "label": "waterTemperature",
        "decimalDigits": 1,
        "unitConverted": "°C",
        "calc": v => v
    },
    {
        "id": 1355,
        "issue": 53984,
        "label": "heatStress",
        "decimalDigits": 1,
        "unitConverted": "°C",
        "calc": v => v
    },
]